<template>
  <v-card>
    <div class="text-left mx-3 my-3" style="font-size: 16px; font-weight: 700">
      Thông tin combo
    </div>

    <div v-if="selectCombo" class="text-left mx-3 my-2">
      Combo <strong>{{ selectCombo.name }}</strong> bao gồm
      <span style="color: #5d62d1">{{ totalProduct() }}</span> sản phẩm
    </div>
    <div class="px-3 pt-2">
      <v-simple-table fixed-header height="300px" class="table-blunk">
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-left font-weight-bold">Tên sản phẩm</th>
            <th class="text-center font-weight-bold">Loại</th>
            <th class="text-center font-weight-bold">Thời hạn học</th>
            <th class="text-center font-weight-bold">Số lượng</th>
            <th class="text-center font-weight-bold">Chính sách ưu đãi</th>
          </tr>
          </thead>
          <tbody v-if="comboIDSelect">
          <tr v-for="(item, index) in listSkuDuos" :key="'SkuDuos' + index">
            <td>{{ item.name }}</td>
            <td class="text-center">Khoá học</td>
            <td class="text-center">
              <span v-if="item.durationType === 'month'">{{item.duration}} tháng</span>
              <span v-if="item.durationType === 'day'">{{formatDateDMY2(item.endDate)}}</span>
            </td>
            <td class="text-center">{{ item.comboDetail.itemQuantity }}</td>
            <td class="text-center">
              <span v-if="item.additionalDuration">Tặng thêm {{item.additionalDuration}} tháng học</span>
              <span v-else>--</span>
            </td>
          </tr>
          <tr
              v-for="(item, index) in listSkuTutors"
              :key="'SkuTutor' + index"
          >
            <td>{{ item.name }}</td>
            <td class="text-center">Gia sư</td>
            <td class="text-center">
              <span>{{item.numOfLesson}} buổi</span>
            </td>
            <td class="text-center">{{ item.comboDetail.itemQuantity }}</td>
            <td class="text-center">
              <span v-if="item.additionalDuration">Tặng thêm {{item.additionalDuration}} buổi học</span>
              <span v-else>--</span>
            </td>
          </tr>
          </tbody>
          <tbody v-else>
          <tr>
            <td colspan="4" class="text-center">Không có dữ liệu</td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
    <div class="d-flex justify-end px-3 py-2">
      <v-btn class="btn-blunk" text @click="$emit('close')"> Đóng </v-btn>
    </div>
  </v-card>
</template>

<script>
import {formatDateDMY2} from "../../../helper/FuncProduct";

export default {
  props: {
    skuCombos: {
      type: Array,
      required: () => [],
    },
    comboIDSelect: {
      type: Number,
      required: null,
    },
  },
  computed: {
    listSkuDuos() {
      let data = [];
      const skuCombo = this.skuCombos.find(
          (item) => item.id === this.comboIDSelect
      );
      if (skuCombo) {
        data = [...skuCombo.skuDuos];
      }
      return data;
    },
    listSkuTutors() {
      let data = [];
      const skuCombo = this.skuCombos.find(
          (item) => item.id === this.comboIDSelect
      );
      if (skuCombo) {
        data = [...skuCombo.skuTutors];
      }
      return data;
    },
    selectCombo() {
      if (!this.comboIDSelect) {
        return null;
      }
      const skuCombo = this.skuCombos.find(
          (item) => item.id === this.comboIDSelect
      );
      if (skuCombo) {
        return skuCombo;
      }
      return null;
    },
  },
  methods: {
    formatDateDMY2,
    totalProduct() {
      let total = 0;
      if (this.listSkuDuos.length > 0) {
        total += this.listSkuDuos.length;
      }
      if (this.listSkuTutors.length > 0) {
        total += this.listSkuTutors.length;
      }
      return total;
    },
  },
};
</script>
<style lang="scss" scoped>
.btn-blunk {
  background-color: #5d62d1 !important;
  color: #fff !important;
}
</style>
